import { addDoc, collection } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { BulletinDataToCreate, BulletinStatus } from "../types";

export const createBulletin = async (
  bulletinData: BulletinDataToCreate,
): Promise<void> => {
  const collectionRef = collection(db, "bulletins");
  await addDoc(collectionRef, {
    ...bulletinData,
    publishedAt:
      bulletinData.status === BulletinStatus.Draft ? null : new Date(),
  });
};
